import { Getter } from 'vuex'
import { RootState } from '@/store/types'
import { SocialDistributionState } from '../types'

const options: Getter<SocialDistributionState, RootState> = (state) => {
  return state.options
}

export default options
